import React, { useEffect } from 'react';
import { PremiumAssetType } from '@wix/ambassador-premium-billing-and-payments/types';
import { Box, Divider } from '@wix/design-system';
import { useUnknownChargeContext } from '../../providers/UnknownChargeProvider';
import {
  makeDateFormatter,
  usePremiumCurrencyFormatter,
} from '@wix/premium-react-text';
import { paymentMethodDisplay } from '@wix/billing-client-common';
import { useAppContext } from '../../providers/AppContextProvider';
import { useResponsiveComponents } from '../../hooks/useResponsiveComponents';
import { useViewport } from '../../hooks/useViewport';
import { useBiLogger } from '../../providers/BiLoggerProvider';

export const DetailsList: React.FC = () => {
  const {
    chargeDetails: {
      amount,
      date,
      description,
      quantity,
      domainName,
      paymentMethod: { label, type },
      subscriptionPeriod,
      invoiceNumber,
      currencyCode,
      service,
    },
  } = useUnknownChargeContext();
  const { biLogger } = useBiLogger();
  const {
    appContext: { locale },
  } = useAppContext();
  const { format: dateFormatter } = makeDateFormatter(locale, 'shortMonth');
  const { shortName, identifier } = paymentMethodDisplay(
    { label, paymentBrand: type },
    locale,
  );
  const [formatCurrency] = usePremiumCurrencyFormatter({ currencyCode });
  const [Responsive] = useResponsiveComponents();
  const { currentBreakpoint } = useViewport();

  useEffect(() => {
    biLogger.chargeDetailsView({
      amount: String(amount),
      invoiceNumber,
      paymentMethod: Number(label),
      productTypeName: service,
      transactionDate: new Date(date).getTime(),
    });
  }, []);
  return (
    <>
      {service === PremiumAssetType.PLAN ? (
        <Responsive.ChargeDetail
          transkey="service-premium-plan"
          keyValues={{ planName: description }}
        />
      ) : (
        <Responsive.ChargeDetail
          transkey="service"
          keyValues={{ productType: description }}
        />
      )}
      {service === PremiumAssetType.MAILBOX && (
        <Responsive.ChargeDetail
          transkey="business-email-details"
          keyValues={{ count: quantity, domainName }}
        />
      )}
      <Responsive.ChargeDetail
        transkey="amount"
        keyValues={{ amount: formatCurrency(amount) }}
      />

      <Responsive.ChargeDetail
        transkey="date"
        keyValues={{ eventDate: date && dateFormatter(date) }}
      />
      <Responsive.ChargeDetail
        transkey="payment-method"
        keyValues={{
          paymentMethod: shortName,
          identifier,
        }}
      />
      {subscriptionPeriod && (
        <Responsive.ChargeDetail
          transkey="subscription-period"
          keyValues={{
            periodStart: dateFormatter(subscriptionPeriod?.startTime!),
            periodEnd: dateFormatter(subscriptionPeriod?.endTime!),
          }}
        />
      )}
      <Responsive.ChargeDetail
        transkey="invoice-number"
        keyValues={{
          invoiceNumber,
        }}
      />
      <Box marginTop={currentBreakpoint.isMobile ? 'SP5' : 'SP8'}>
        <Divider />
      </Box>
    </>
  );
};
